window.$mm_performance_result = [];
window.$mm_performance_treeChangeStatus = false;
window.$mm_performance_page_number = 1;
window.$mm_performance_Glist = [];
window.$mm_performance_selectedRow = "";
window.$mm_performance_content = [];
window.$mm_performance_lastUsedTableFilter = [];
window.$mm_performance_scroll_change = false;
window.$mm_performance_filterClickStatus = false;
window.$mm_performance_filterLastIds = [];
window.$mm_performance_searchInputId = null;
window.$mm_performance_columnList = [];
//Columns
window.$mm_performance_performanceAlgemeenGisratio = [];
window.$mm_performance_maatregelNaam = [];
window.$mm_performance_planning_globaleplanning = [];
window.$mm_performance_planning_detailplanning = [];
window.$mm_performance_performanceStatus = [];
window.$mm_performance_disciplineNaam = [];
window.$mm_performance_werkplanNaam = [];
window.$mm_performance_planningsPeriodeStartdatum = [];
window.$mm_performance_statusTijdstipVerzonden = [];
window.$mm_performance_plannigStatus = [];
window.$mm_performance_filterCheckControlGPlannig = [false, false];
window.$mm_performance_gvv = 1;
window.$mm_performance_last_search_id = 1;
window.$mm_performance_table_total_row_count = 0;
window.$mm_performance_columnListPure = null;
window.$mm_performance_refresh = function (){};
window.$mm_performance_filterCheckControl = [
  ["status-detailplanning", false, false],
  ["status-budget", false, false],
  ["status-uitvoering", false, false],
  ["status-werkplan", false, false],
  ["planning-iscorrectiefonderhoud", false, false],
  ["status-verzonden", false, false],
];
window.$mm_performance_filterClickControl = [
  ["status-detailplanning", false],
  ["status-budget", false],
  ["status-uitvoering", false],
  ["status-werkplan", false],
  ["planning-iscorrectiefonderhoud", false],
  ["status-verzonden", false],
];
window.$mm_performance_filterContent = [
  {
    key: "status-verzonden",
    and_or: "AND",
    values: [true],
    datatype: "BOOLEAN",
  },
];
window.$mm_performance_actions = [
  {
    id: "57d136a2-9749-46d4-85c4-edda4de75409",
    text: "Plaats in budget",
    class: "locate",
    modal: "performance_plaats_in_budget",
  },
  {
    id: "3a98846b-67c1-4192-9edc-b980f10898b8",
    text: "Wijzig status",
    class: "locate",
    modal: "wijzig_status",
  },
  {
    id: "b57232b9-090e-45f8-9729-3c768e12f650",
    text: "Verwijder uit uitvoering",
    class: "locate",
    modal: "performance_verwijder_uitvoering",
  },
  {
    id: "1041f11d-46f4-4a46-a1c5-8e6d91f0877f",
    text: "Plaats in werkplan",
    class: "locate",
    modal: "plaats_in_werkplan",
  },
  {
    id: "7492187b-a23f-4216-a303-69b8cb1e7535",
    text: "Plaats in werkorder",
    class: "locate",
    modal: "performance_plaats_in_werkorder",
  },
  {
    id: "pe_toon_dossiers_op_kaart",
    text: "pe_toon_dossiers_op_kaart",
    class: "locate",
    modal: "",
  },
];

window.$mm_performance_column_order_post_model = {
  client_identification: "",
  code: "",
  data: {
    table_sorting: [
      {
        name: "management-maintenance>performance",
        column_list: [
          "checkbox",
          "active",
          "status_detailplanning",
          "status_budget",
          "status_uitvoering",
          "status_werkplan",
          "planning_iscorrectiefonderhoud",
          "status_verzonden",
          "Gisratio Id",
          "Naam maatregel",
          "Globale planning",
          "Detail planning",
          "Status",
          "Naam discipline",
          "Naam werkplan",
          "Startdatum Planningsperiode",
          "Tijdstip verzonden",
        ],
      },
    ],
  },
};
